import React, { useEffect, useState } from "react";
import ImageCarousel from "../../../components/ImageCarousel";
import classes from "../Registration/index.module.css";
import { GrFormEdit } from "react-icons/gr";
import OtpInput from "react-otp-input";
import { OTP_LOGIN, VERIFY_LOGIN_OTP } from "../../../api-calls/api-urls";
import AppLogo from "../../../assets/images/mainLogo.png";
import { ValidatorForm } from "react-material-ui-form-validator";
import "../../../assets/css/style.css";
import { loggedUser, pageLoader } from "../../../Redux/actions/user-actions";
import {
  Card,
  Typography,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  api,
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { getLanguagedataFunction } from "../../../utilities/language";
import Cookies from "js-cookie";
import AlertBox from "../../../components/AlertBox";
import { Numeric } from "../../../utilities/commonFunctions";
const OtpLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Otp, setOtp] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [time, setTime] = useState(15);
  const [isEdit, setIsEdit] = useState(false);
  const otp = JSON.parse(sessionStorage.getItem("loginOtp"));
  const phone = JSON.parse(sessionStorage.getItem("mobile"));
  const [mobile, setMobile] = useState(phone);
  const ln = useSelector((state) => state.allUsers.language_json);
  const [disable, setDisable] = useState({
    name: ln ? `${ln.resend_in} ${time}${ln.seconds}` : null,
    state: true,
  });

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = crypto.randomUUID ? crypto.randomUUID() : 'device-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("deviceId", deviceId);
    }
    return deviceId;
  };

  const getDeviceName = () => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes("Edg")) return "Edge Browser";
    if (userAgent.includes("Chrome")) return "Chrome Browser";
    if (userAgent.includes("Firefox")) return "Firefox Browser";
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari Browser";
    return "Web Browser";
  };

  const handleSubmit = async () => {
    const userEntry = {
      otp: Otp,
      phone: mobile,
      deviceId: getOrCreateDeviceId(),
      deviceName: getDeviceName(),
    };
    try {
      dispatch(pageLoader(true));
      const { data } = await api.post(VERIFY_LOGIN_OTP, userEntry);
      dispatch(pageLoader(false));
      if (data.user_type === "team_player") {
        setShowAlert(true);
        setError("Team Leader Only has a Access");
      } else {
        await sessionStorage.setItem("userInfo", JSON.stringify(data));
        dispatch(loggedUser(data));
        const rememberMe = sessionStorage.getItem("rememberMe");
        if (rememberMe && data && data.token) {
          Cookies.set("userToken", JSON.stringify(data), { expires: 7 });
          sessionStorage.removeItem("rememberMe");
        }
        navigate("/home");
      }
    } catch (error) {
      dispatch(pageLoader(false));
      if (error.response && error.response.status === 400) {
        setShowAlert(true);
        setError(error.response.data.message);
      } else {
        // Handle other errors
        // ...
      }
    }
  };
  // useEffect(() => {
  //   if (!localStorage.getItem("CurrentUser")) {
  //     navigate("/personal-details");
  //   }
  // }, []);
  const handleOnchange = (e) => {
    const re = /^\d*$/;
    if (e === "" || re.test(e)) {
      setOtp(e);
    }
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevCount) => prevCount - 1);
      setDisable({
        name: `${ln.resend_in} ${time - 1}${ln.seconds}`,
        state: true,
      });
    }, 1000);

    if (time === 0) {
      clearInterval(timer);
      setDisable({
        name: ln.resend_otp,
        state: false,
      });
    }
    return () => {
      clearInterval(timer);
    };
  }, [time, ln]);

  const handleResetClick = () => {
    setOtp(null);
    setTime(15);
    handleOtp();
  };

  const handleOtp = async () => {
    try {
      const userEntry = {
        phone: mobile,
      };
      const { data } = await authApi.post(OTP_LOGIN, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      sessionStorage.setItem("loginOtp", JSON.stringify(data));
      // setOtpReceived(true);
    } catch (error) {
        console.log(error);
    }
  };

  const handleOtpLogin = async () => {
    const userEntry = {
      phone: mobile,
    };
    try {
      dispatch(pageLoader(true));
      const { data } = await api.post(OTP_LOGIN, userEntry);
      sessionStorage.setItem("mobile", JSON.stringify(mobile));
      sessionStorage.setItem("loginOtp", JSON.stringify(data));
      navigate("/otp_login");
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setShowAlert(true);
        setError(error.response.data.message);
      }
    }
  };

  const HandleNumberChange = () => {
    setIsEdit(false);
    handleOtpLogin();
  };

  useEffect(() => {}, []);
  return (
    <div className={classes.maindivForlogin}>
      {ln ? (
        <Card className={classes.SelectLanguage_maindiv}>
          <div>
            <ImageCarousel />
          </div>
          <ValidatorForm useref="form" onSubmit={handleSubmit}>
            <div className={classes.MaincntainerDiv}>
              <div className={classes.formContent}>
                <div>
                  <span className={classes.mb_5}>
                    <img src={AppLogo} alt="" height={50} />
                  </span>
                  <Typography className={classes.loginHeading}>
                    {ln.verify_otp}
                  </Typography>
                  <Typography className={classes.loginDescription}>
                    {ln.enter_otp_mobile} <br />
                    {isEdit ? (
                      <div className={`${classes.mb_3} ${classes.mt_4}`} style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "200px",
                          }}
                          inputProps={{
                            maxLength: 10,
                          }}
                          id="phonenumberInput"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          onKeyPress={(e) => Numeric(e)}
                          variant="standard"
                          size="small"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                +91
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Button
                          variant="contained"
                          onClick={() => HandleNumberChange()}
                          className={classes.otpNumberUpdateBytn}
                        >
                          update
                        </Button>
                      </div>
                    ) : (
                      <div className={classes.mt_4}>
                        <b className={classes.boldContainer}>
                          <span className={classes.mobileNumber}>
                            +91 {mobile}
                          </span>{" "}
                          <span
                            onClick={() => setIsEdit(true)}
                            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                          >
                            <GrFormEdit size={24} />
                          </span>
                        </b>
                      </div>
                    )}
                  </Typography>
                  {otp ? (
                    <Typography className={classes.mt_4} style={{ color: "#6b778c" }}>
                      Your Phone OTP is: <b>{otp.otp || otp.phone_otp}</b>
                    </Typography>
                  ) : null}
                </div>

                <div className={classes.mt_4}>
                  <div className={classes.OtpFeildsContainer}>
                    <OtpInput
                      value={Otp}
                      onChange={(e) => handleOnchange(e)}
                      numInputs={4}
                      renderInput={(props) => <input {...props} />}
                      isInputNum={true}
                    />
                  </div>
                  <div className={classes.mt_4}>
                    <p className={classes.login_form_lable}>
                      {ln.didnt_recieve_otp}
                      <Button
                        disabled={disable.state}
                        className={`${classes.login_form_lable} ${classes.remember_input} ${classes.forgotbtn}`}
                        variant="text"
                        sx={{
                          "&.Mui-disabled": {
                            color: "#0a1f4173 !important",
                          },
                        }}
                        style={{
                          cursor: "pointer",
                          border: "none",
                          textTransform: "none",
                          marginLeft: "5px",
                        }}
                        onClick={() => handleResetClick()}
                      >
                        {disable.name}
                      </Button>
                    </p>
                  </div>
                  <div className={classes.mt_4}>
                    <Button
                      disabled={Otp && Otp?.length === 4 ? false : true}
                      variant="contained"
                      type="submit"
                      className={classes.commonbtn}
                    >
                      {ln.continue}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </ValidatorForm>
        </Card>
      ) : null}
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default OtpLogin;
